var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickveeLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3336",
    "data-name": "Rectangle 3336",
    width: 36,
    height: 36,
    transform: "translate(114.568 301.047)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5941",
    "data-name": "Mask Group 5941",
    transform: "translate(-114.568 -301.047)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7914",
    "data-name": "Group 7914",
    transform: "translate(120.541 306.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7913",
    "data-name": "Group 7913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7911",
    "data-name": "Group 7911",
    transform: "translate(4.718 7.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7909",
    "data-name": "Group 7909",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    d: "M644.379,435.192a1.2,1.2,0,0,1-.675-.207l-1.943-1.315a1.2,1.2,0,1,1,1.35-1.994l1.27.859,1.253-.844a1.2,1.2,0,0,1,1.346,2l-1.927,1.3A1.2,1.2,0,0,1,644.379,435.192Z",
    transform: "translate(-641.231 -431.468)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7910",
    "data-name": "Group 7910",
    transform: "translate(7.291 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    d: "M690.646,435.193a1.2,1.2,0,0,1-.675-.207l-1.943-1.315a1.2,1.2,0,1,1,1.35-1.995l1.27.859,1.253-.844a1.2,1.2,0,0,1,1.346,2l-1.927,1.3A1.2,1.2,0,0,1,690.646,435.193Z",
    transform: "translate(-687.498 -431.47)",
    fill: "#0a64f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7912",
    "data-name": "Group 7912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9074",
    "data-name": "Path 9074",
    d: "M626.3,399.023l-1.966,1.966,2.005,2.005a8.734,8.734,0,1,1,3.369-2.655l-.2.264,1.973,1.973.265-.328a11.545,11.545,0,1,0-3.336,2.813l3.36,3.36,1.966-1.966Z",
    transform: "translate(-611.29 -383.527)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3335",
    "data-name": "Rectangle 3335",
    width: 2.781,
    height: 0.821,
    transform: "translate(20.954 25.373) rotate(-44.995)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_377",
    "data-name": "Ellipse 377",
    cx: 1.183,
    cy: 1.183,
    r: 1.183,
    transform: "translate(21.52 18.671)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_378",
    "data-name": "Ellipse 378",
    cx: 0.699,
    cy: 0.699,
    r: 0.699,
    transform: "translate(22.972 21.36)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_379",
    "data-name": "Ellipse 379",
    cx: 0.538,
    cy: 0.538,
    r: 0.538,
    transform: "translate(23.618 17.649)",
    fill: "#0a64f9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickveeLogoSymbol);
export default __webpack_public_path__ + "static/media/QuickveeLogoSymbol.3dd2b6a2ca2ae5a4ffa0f09d0832c02c.svg";
export { ForwardRef as ReactComponent };